export const PHONE = 320
export const PHONE_WIDE = 576
export const TABLET = 768
export const TABLET_WIDE = 1024
export const DESKTOP = 1248
export const DESKTOP_WIDE = 1440
export const FULL_HD = 1920

const mediaQueries = {
  desktop: {
    down: window.matchMedia(`(max-width: ${DESKTOP - 1}px)`),
    up: window.matchMedia(`(min-width: ${DESKTOP}px)`)
  },
  desktopWide: {
    down: window.matchMedia(`(max-width: ${DESKTOP_WIDE - 1}px)`),
    up: window.matchMedia(`(min-width: ${DESKTOP_WIDE}px)`)
  },
  fullHd: {
    down: window.matchMedia(`(max-width: ${FULL_HD - 1}px)`),
    up: window.matchMedia(`(min-width: ${FULL_HD}px)`)
  },
  phone: {
    down: window.matchMedia(`(max-width: ${PHONE - 1}px)`),
    up: window.matchMedia(`(min-width: ${PHONE}px)`)
  },
  phoneWide: {
    down: window.matchMedia(`(max-width: ${PHONE_WIDE - 1}px)`),
    up: window.matchMedia(`(min-width: ${PHONE_WIDE}px)`)
  },
  tablet: {
    down: window.matchMedia(`(max-width: ${TABLET - 1}px)`),
    up: window.matchMedia(`(min-width: ${TABLET}px)`)
  },
  tabletWide: {
    down: window.matchMedia(`(max-width: ${TABLET_WIDE - 1}px)`),
    up: window.matchMedia(`(min-width: ${TABLET_WIDE}px)`)
  }
}

export const isDesktopDown = (): boolean => mediaQueries.desktop.down.matches

export const isDesktopUp = (): boolean => mediaQueries.desktop.up.matches

export const isDesktopWideDown = (): boolean => mediaQueries.desktopWide.down.matches

export const isDesktopWideUp = (): boolean => mediaQueries.desktopWide.up.matches

export const isFullHdDown = (): boolean => mediaQueries.fullHd.down.matches

export const isFullHdUp = (): boolean => mediaQueries.fullHd.up.matches

export const isPhoneDown = (): boolean => mediaQueries.phone.down.matches

export const isPhoneUp = (): boolean => mediaQueries.phone.up.matches

export const isPhoneWideDown = (): boolean => mediaQueries.phoneWide.down.matches

export const isPhoneWideUp = (): boolean => mediaQueries.phoneWide.up.matches

export const isTabletDown = (): boolean => mediaQueries.tablet.down.matches

export const isTabletUp = (): boolean => mediaQueries.tablet.up.matches

export const isTabletWideDown = (): boolean => mediaQueries.tabletWide.down.matches

export const isTabletWideUp = (): boolean => mediaQueries.tabletWide.up.matches
